<template>
    <div>
        <v-app>
            <v-data-table :headers="headers" :items="modelResourceList" hide-default-footer class="paginated-table table-striped table-hover" style="padding-top: 10px">
                <template v-slot:item.template="{ item }">{{ tempMap[item.template] </template>
                <template v-slot:item.option="{ item }">
                    <md-button class="md-just-icon md-success md-round md-simple" @click.native="handleEdit(item)" style="padding-right: 30px;">
                        <md-icon>edit</md-icon>
                    </md-button>
                    <md-button class="md-just-icon md-danger md-round md-simple" @click.native="handleDelete(item)">
                        <md-icon>close</md-icon>
                    </md-button>
                </template>
            </v-data-table>
        </v-app>
    </div>
</template>
<script>
import { Pagination } from '@/components'
export default {
    components: {
        Pagination
    },
    props: {
        list: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            headers: [
                { text: '动作名称', align: 'center', value: 'name' },
                { text: '动作模板', align: 'center', value: 'template' },
                { text: '编辑', align: 'center', value: 'option', width: "100px" }
            ],
            pagination: {
                perPage: 5,
                currentPage: 1,
                perPageOptions: [5, 10, 25, 50],
                total: 0
            },
            searchQuery: '',
            tempMap: {
                bfdh: '播放动画'
            }
        }
    },
    computed: {
        to() {
            let highBound = this.from + this.pagination.perPage
            if (this.total < highBound) {
                highBound = this.total
            }
            return highBound
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1)
        },
        total() {
            return this.list.length
        }
    },
    methods: {
        handleEdit(index) {
            this.$emit('handleEdit', index)
        },
        handleDelete(index) {
            this.$emit('handleDelete', index)
        }
    }
}
</script>
<style></style>